import {createStore} from 'vuex';
import {logger, sessionPersistence,localPersistence} from './plugins/index';
import search  from './modules/search';
import reader  from './modules/reader';
import cache  from './modules/cache';

export default createStore({
    state: {
        pdaToken: '',
        csrfToken:'',
        addressId: '',
        loadingConfs: false,
        config: {}, // 配置文件
        baseConfig: {}, // 接口返回配置文件
        scrollTop:0,
    },
    mutations: {
        addToken(state: any, value: any) {
            state.pdaToken = value;
        },
        addAddressId(state: any, value: any) {
            state.addressId = value;
        },
        setLoadingConfs(state: any, value: any) {
            state.loadingConfs = value;
        },
        setConfig(state: any, value: any) {
            state.config = value;
        },
        setBaseConfig(state: any, value: any) {
            state.baseConfig = value;
        },
        setScrollTop(state: any, value: any) {
            state.scrollTop = value;
        }
    },
    plugins: [logger, sessionPersistence,localPersistence],
    modules: {
        search : {
            ...search
        },
        reader : {
            ...reader
        },
        cache : {
            ...cache
        }
    }
});

